import React, { FC } from 'react';
import 'react-responsive-modal/styles.css';
import { toast } from 'react-toastify';
import { useStoreon } from 'storeon/react';
import { api } from '@/api';
import { Events, State } from '@/interfaces';
import Button from '../../../../../components/Button';
import { TASKS_STATUS_TYPE } from '../../../const';
import styles from './styles/index.module.scss';


interface IModalChangeTaskFooter {
    currentTask: any,
    onClose: any,
}

const ModalChangeTaskFooter: FC<IModalChangeTaskFooter> = (
    {
        currentTask, onClose
    }) => {
    const { dispatch } = useStoreon<State, Events>()

    const startTask = async () => {
        try {
            await api.task.startTask(currentTask.id)
            dispatch('tasks/get')
            onClose()
        } catch (e) {
            toast.error(`Задачa: "${currentTask.title}" не была начата!`)
            console.log(e);
        }
    }

    const closeTask = async () => {
        try {
            await api.task.closeTask(currentTask.id)
            dispatch('tasks/get')
            onClose()
        } catch (e) {
            toast.error(`Задачa: "${currentTask.title}" не была закрыта!`)
            console.log(e);
        }
    }

    return (
        <>
            <div className={styles['footer']}>
                {TASKS_STATUS_TYPE.NEW === currentTask.state_status ?
                    <Button onClick={startTask} theme='btn--success'>Начать</Button>
                    :
                    TASKS_STATUS_TYPE.CLOSED !== currentTask.state_status &&
                    <Button onClick={closeTask} theme='btn--success'>Завершить</Button>
                }
            </div>
        </>
    )
}

export default ModalChangeTaskFooter;